import { FC } from 'react';
import styled from 'styled-components';

import { ScenarioStatus as ScenarioStatusType } from '@/shared/api/types';
import { COLORS } from '@/shared/constants/colors';

import { getStatusName } from '../helpers';

type ScenarioStatusV2Props = {
  status: ScenarioStatusType;
};

export const ScenarioStatusV2: FC<ScenarioStatusV2Props> = ({ status }) => (
  <Container className={getClassNameByStatus(status)}>
    <Circle />
    {getStatusName(status)}
  </Container>
);

const Container = styled.div`
  height: 20px;
  display: flex;
  align-items: center;
  gap: 6px;

  &.active {
    --status-color: ${COLORS.systemSun200};
  }
  &.done {
    --status-color: ${COLORS.systemForest200};
  }
  &.draft {
    --status-color: ${COLORS.systemDark100};
  }
`;

const Circle = styled.div`
  flex-shrink: 0;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--status-color);
`;

const getClassNameByStatus = (status: ScenarioStatusType): string => {
  switch (status) {
    case ScenarioStatusType.Active:
    case ScenarioStatusType.InProgress:
      return 'active';

    case ScenarioStatusType.Done:
      return 'done';

    case ScenarioStatusType.Draft:
    case ScenarioStatusType.Canceled:
    default:
      return 'draft';
  }
};
